module.exports = function() {
  try {
    if (window.location.search) {
      const search = window.location.search.substring(1);
      return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
    }
    return '';
  } catch (err) {
    console.error('Failed to parse query: ', err)
  }
}